package team.platforma.chat_data.database.draft

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.emptyFlow
import team.platforma.chatdata.database.ChatDatabase
import team.platforma.chatdata.table.Draft

class DraftTableImpl(
    private val chatDatabase: ChatDatabase
) : DraftTable {
    override suspend fun insertDraft(draft: Draft) {
        println("INSERT_DRAFT: $draft")
        chatDatabase.draftQueries.insertDraft(
            aiModelID = draft.aiModelID,
            userID = draft.userID,
            chatID = draft.chatID,
            text = draft.text
        )
    }

    override suspend fun updateDraft(draftId: Long, text: String, chatId: Long) {
        chatDatabase.draftQueries.updateDraft(
            text = text,
            chatID = chatId,
            draftID = draftId
        )
    }

    override fun observeDraftList(aiModelID: Long?, userID: Long, chatID: Long): Flow<List<Draft>> {
        return if (aiModelID == null) {
            emptyFlow()
        }  else {
            chatDatabase.draftQueries.selectByModelUser(aiModelID, userID, chatID).asFlow()
                .mapToList(Dispatchers.Default)
        }
    }

}